import React, { useEffect } from 'react';
import { Button } from 'app/components/ui/button';
import { useNavigate, useParams } from 'react-router-dom';
import { useCourseSlice } from '../slice';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { Form } from 'app/components/ui/form';
import CourseForm from '../Form';

export default function EditCourse() {
  const form = useForm({
    defaultValues: {
      status: 2,
    },
  });

  const { useLazyGetCourseDetailQuery, useUpdateCourseMutation } =
    useCourseSlice();
  const [getCourseDetails, { isError, isLoading, data: courseData }] =
    useLazyGetCourseDetailQuery();
  const [
    updateCourse,
    { isLoading: updating, error: updateErr, data: success },
  ] = useUpdateCourseMutation();

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      console.log(`Fetching course details for ID: ${id}`);
      getCourseDetails(id);
    }
  }, [id, getCourseDetails]);

  useEffect(() => {
    if (isError) {
      console.error('Error fetching course details');
      toast.error('Failed to fetch course details');
    }
  }, [isError]);

  useEffect(() => {
    if (courseData) {
      console.log('Fetched course data:', courseData);
      patchValues(courseData.data);
    }
  }, [courseData]);

  const patchValues = data => {
    console.log('Patching form values:', data);
    Object.keys(data).forEach(key => {
      form.setValue(key, data[key]);
    });
  };

  const onSubmit = async values => {
    console.log('Submitting form with values:', values);
    updateCourse(values);
  };

  useEffect(() => {
    console.log('Update response:', { success, updateErr });

    if (success) {
      console.log('Course updated successfully:', success);
      toast.success('Course updated successfully');
      navigate('/courses');
    }
    if (updateErr) {
      console.error('Error updating course:', updateErr);
      toast.error('Something went wrong');
    }
  }, [navigate, success, updateErr]);

  return (
    <div className="bg-gray-100 min-h-screen p-4">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold">Edit Course</h3>
            <Button type="submit" disabled={isLoading || updating}>
              {isLoading || updating ? 'Saving...' : 'Save Changes'}
            </Button>
          </div>
          <CourseForm />
        </form>
      </Form>
    </div>
  );
}
